'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$() {
}
export { $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$ as $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$ };
$p = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$;
/** @constructor */
function $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$() {
}
export { $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$ as $h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$ };
$h_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return 2603341;
});
$p.b = (function() {
  return "Text";
});
$p.n = (function() {
  return 0;
});
$p.o = (function() {
  return "Text";
});
$p.g = (function(n) {
  throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.y = (function(p) {
  return this;
});
var $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$, "be.doeraene.webcomponents.ui5.configkeys.InputType$Text$", ({
  gA: 1,
  b0: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$ as $d_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$ };
var $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$;
function $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$() {
  if ((!$n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$)) {
    $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$ = new $c_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$();
  }
  return $n_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$;
}
export { $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$ as $m_Lbe_doeraene_webcomponents_ui5_configkeys_InputType$Text$ };
